import _ from 'lodash';
import moment from 'moment';

import {
  capitalizeSentenceWords,
  sanitizeSpecialChars,
  trimSpaces,
  sanitizeHyphenatedLastName,
} from '../../helpers/utils';
import { adminLevelLabels } from '../../helpers/mappings';

export const modelFields = [
  {
    fields: [
      {
        field: 'First Name',
        order: 0,
        isSelected: true,
      },
      {
        field: 'Middle Name',
        order: 1,
        isSelected: true,
      },
      {
        field: 'Last Name',
        order: 2,
        isSelected: true,
      },
    ],
    order: 0,
  },
  {
    fields: [
      {
        field: 'Email',
        order: 0,
        isSelected: true,
      },
    ],
    order: 1,
  },
  {
    fields: [
      {
        field: 'Account Number',
        order: 0,
        isSelected: true,
      },
    ],
    order: 2,
  },
  {
    fields: [
      {
        field: 'Sign Up Completed At',
        order: 0,
        isSelected: true,
      },
    ],
    order: 3,
  },
  {
    fields: [
      {
        field: 'Email Verified At',
        order: 0,
        isSelected: true,
      },
    ],
    order: 4,
  },
  {
    fields: [
      {
        field: 'Approved At',
        order: 0,
        isSelected: true,
      },
    ],
    order: 5,
  },
  {
    fields: [
      {
        field: 'Role',
        order: 0,
        isSelected: true,
      },
    ],
    order: 6,
  },
  {
    fields: [
      {
        field: 'Last Sign In At',
        order: 0,
        isSelected: false,
      },
    ],
    order: 7,
  },
  {
    fields: [
      {
        field: 'Created At',
        order: 0,
        isSelected: true,
      },
    ],
    order: 8,
  },
  {
    fields: [
      {
        field: 'Updated At',
        order: 0,
        isSelected: true,
      },
    ],
    order: 9,
  },
  {
    fields: [
      {
        field: 'Status',
        order: 0,
        isSelected: true,
      },
    ],
    order: 10,
  },
  {
    fields: [
      {
        field: 'Account Closed At',
        order: 0,
        isSelected: true,
      },
    ],
    order: 11,
  },
];

export const transformDataForExportFn = (data, chosenFields) => {
  const mapped = data.map(element => [
    { key: 'First Name', value: trimSpaces(capitalizeSentenceWords(sanitizeSpecialChars(element.firstName, /[.,-]/g))) },
    { key: 'Middle Name', value: trimSpaces(capitalizeSentenceWords(sanitizeSpecialChars(element.middleName, /[.,-]/g))) },
    { key: 'Last Name', value: sanitizeHyphenatedLastName(trimSpaces(capitalizeSentenceWords(sanitizeSpecialChars(element.lastName, /[.,]/g)))) },
    { key: 'Last Name', value: element.email },
    { key: 'AccountNumber', value: element.Accounts && element.Accounts.length > 0 ? element.Accounts[0].accountNumber : '' },
    { key: 'Sign Up Completed At', value: moment(new Date(element.signUpCompletedAt)).format('DD/MM/YYYY') },
    { key: 'Email Verified At', value: moment(new Date(element.emailVerifiedAt)).format('DD/MM/YYYY') },
    { key: 'Approved At', value: moment(new Date(element.approvedAt)).format('DD/MM/YYYY') },
    { key: 'Role', value: _.values(adminLevelLabels).find(item => item.id === element.role).name },
    { key: 'Last Sign In At', value: moment(new Date(element.lastSignInAt)).format('DD/MM/YYYY') },
    { key: 'Created At', value: moment(new Date(element.createdAt)).format('DD/MM/YYYY') },
    { key: 'Updated At', value: moment(new Date(element.updatedAt)).format('DD/MM/YYYY') },
    { key: 'Status', value: element.status },
    {
      key: 'Account Closed At',
      value: element.Accounts && element.Accounts.length > 0 && element.Accounts[0].closedAt ?
        moment(new Date(element.Accounts[0].closedAt)).format('DD/MM/YYYY') : '',
    },
  ].filter(({ key }) => chosenFields.includes(key)).reduce((obj, { key, value }) => ({ ...obj, [key]: value }), {}));
  return mapped;
};



// WEBPACK FOOTER //
// ./src/components/User/constants.js